import type { PaginationParam } from "../types/paginationResponse";

/**
 * Builds a query string from pagination parameters
 * @param pagination - Optional pagination parameters
 * @returns Query string (e.g., "?page=1&pageSize=10" or "")
 */
export const buildPaginationQuery = (pagination?: PaginationParam): string => {
  if (!pagination) return "";

  const params = new URLSearchParams();
  if (pagination.page) params.append("page", pagination.page.toString());
  if (pagination.pageSize) params.append("pageSize", pagination.pageSize.toString());

  const queryString = params.toString();
  return queryString ? `?${queryString}` : "";
};
